import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors, Duration, EasingValues } from '@lichtblick/theme';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { Box } from '../../atoms/Box/Box';
import { Text } from '../../atoms/Text/Text';
import { Background, Root, Tab, TabContainer, TabList, TabListContainer } from './Tabs.styles';
export const Tabs = ({ backgroundColor = Colors.White, className, customContentProps, gap, layoutID, mobileNavAlignment, onActiveTabChange, tabs })=>{
    const [activeTab, setActiveTab] = useState(0);
    /**
   * If there is more than one tab menu, Framer Motion must determine
   * for which component to animate the active state indicator.
   * If it is not passed directly, it is assumed (!) that the
   * combination of all tab names is unique.
   */ const uniqueLayoutID = layoutID || tabs.map((tab)=>tab.headline).join('-');
    const { contentSlot: activeContent, headline: activeHeadline } = tabs[activeTab];
    const onTabClicked = (index)=>{
        setActiveTab(index);
        onActiveTabChange?.(index);
    };
    return /*#__PURE__*/ _jsxs(Root, {
        $gap: gap,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(TabListContainer, {
                "$aria-orientation": "horizontal",
                role: "tabpanel",
                children: /*#__PURE__*/ _jsx(TabList, {
                    $backgroundColor: backgroundColor,
                    $mobileNavAlignment: mobileNavAlignment ?? 'row',
                    children: tabs.map(({ headline, subline }, index)=>{
                        const isActive = index === activeTab;
                        const key = `${uniqueLayoutID}-${headline}-${index}`;
                        return /*#__PURE__*/ _jsx(TabContainer, {
                            children: /*#__PURE__*/ _jsxs(Tab, {
                                onClick: ()=>onTabClicked(index),
                                'aria-selected': isActive,
                                'aria-controls': headline,
                                'aria-label': headline,
                                "data-testid": `${uniqueLayoutID}-tab-${index}`,
                                isActive: isActive,
                                role: "tab",
                                tabIndex: index + 1,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        align: "center",
                                        isBold: true,
                                        size: "S",
                                        children: headline
                                    }),
                                    subline ? /*#__PURE__*/ _jsx(Text, {
                                        align: "center",
                                        size: "S",
                                        children: subline
                                    }) : null,
                                    isActive && /*#__PURE__*/ _jsx(Background, {
                                        layoutId: uniqueLayoutID,
                                        transition: {
                                            ease: EasingValues.Outro
                                        }
                                    })
                                ]
                            })
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("main", {
                'aria-labelledby': activeHeadline,
                children: /*#__PURE__*/ _jsx(Box, {
                    ...customContentProps,
                    children: /*#__PURE__*/ _jsx(AnimatePresence, {
                        mode: "wait",
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            animate: {
                                y: 0,
                                opacity: 1
                            },
                            exit: {
                                y: -10,
                                opacity: 0
                            },
                            initial: {
                                y: 10,
                                opacity: 0
                            },
                            transition: {
                                ease: EasingValues.Outro,
                                duration: Duration.SmallOutro / 1000
                            },
                            children: activeContent
                        }, activeTab)
                    })
                })
            })
        ]
    });
};

//# sourceMappingURL=Tabs.js.map